const config = {
    appName: "luvo",
    assets: {
        css: {},
        js: {},
    },
    desktopBp: "lg",
    fancyboxOptions: {
        default: {
            /**
             * The below will have to be wrapped in a Carousel: {} for Fancybox
             * version 6
             */
            Thumbs: false,
            on: {
                ready: (fancybox) => {
                    window.dispatchEvent(
                        new CustomEvent(`${config.appName}/fancyboxReady`, {
                            detail: {fancybox},
                        }),
                    );
                },
            },
        },
        inlineHtml: {
            autoFocus: false, // Option removed in Fancybox version 6
            Carousel: {
                Panzoom: {
                    touch: false,
                },
            },
            on: {
                ready: (fancybox) =>
                    fancybox.container.classList.add("is-inline-html"),
            },
        },
    },
    mainNav: document.getElementById("main-nav"),
    masthead: document.getElementById("masthead"),
    plugins: {},
    responsiveBps: {
        xxs: 0,
        xs: 480,
        sm: 576,
        gravityLg: 640,
        md: 768,
        lg: 992,
        xl: 1200,
        deskSm: 1400,
        deskMd: 1600,
        deskLg: 1920,
        deskXl: 2560,
    },
    responsiveTypes: {
        mobile: ["xxs", "xs", "sm"],
        tabletProfile: ["md"],
        tabletLandscape: ["lg"],
        desktop: ["xl", "deskSm", "deskMd", "deskLg", "deskXl"],
    },
    wpAdminBar: document.getElementById("wpadminbar"),
};
config.prefix = `--${config.appName}-`;
config.fancyboxOptions.inlineHtml = {
    ...config.fancyboxOptions.default,
    ...config.fancyboxOptions.inlineHtml,
};
const fancyboxInlineHtmlReadyCallback =
    config.fancyboxOptions.inlineHtml.on.ready;
config.fancyboxOptions.inlineHtml.on.ready = (fancybox) => {
    config.fancyboxOptions.default.on.ready(fancybox);
    fancyboxInlineHtmlReadyCallback(fancybox);
};

config.navbarToggler = config.masthead?.querySelector(".navbar-toggler");

const getConfig = () => config;
const updateConfig = (newConfig) => Object.assign(config, newConfig);

export default getConfig;
export {getConfig, updateConfig};
